export default __webpack_public_path__ + "static/respo-fad198b9f6ae5e49d76f76a8c654dd15.svg";